import { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import api from "../../services/api";
import ProposalEditor from "./ProposalEditor";

export default function QuoteForm({ quote, onSave, onCancel }) {
  var insurersState = useState([]);
  var insurers = insurersState[0];
  var setInsurers = insurersState[1];
  var formState = useState({
    client_id: quote ? quote.client_id : "",
    client_name: quote ? quote.client_name : "",
    insurance_type: quote ? quote.insurance_type : "auto",
    description: quote ? quote.description : "",
    details: quote ? (quote.details || "") : "",
    proposals: quote ? (quote.proposals || []) : [],
    status: quote ? quote.status : "aberta",
    selected_index: quote ? quote.selected_index : null,
  });
  var form = formState[0];
  var setForm = formState[1];
  var savingState = useState(false);
  var saving = savingState[0];
  var setSaving = savingState[1];

  useEffect(function() {
    api.get("/insurers?active_only=true").then(function(r) { setInsurers(r.data.insurers || []); });
  }, []);

  function handleChange(field, value) {
    setForm(function(prev) { var n = {}; for (var k in prev) n[k] = prev[k]; n[field] = value; return n; });
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    if (quote) {
      var updatePayload = { description: form.description, details: form.details || null, proposals: form.proposals, status: form.status, selected_index: form.selected_index };
      api.put("/quotes/" + quote.id, updatePayload).then(function() { onSave(); }).finally(function() { setSaving(false); });
    } else {
      var createPayload = { client_id: form.client_id, client_name: form.client_name, insurance_type: form.insurance_type, description: form.description, details: form.details || null, proposals: form.proposals };
      api.post("/quotes", createPayload).then(function() { onSave(); }).finally(function() { setSaving(false); });
    }
  }

  var isEdit = !!quote;

  return (
    <div data-testid="quote-form">
      <button onClick={onCancel} className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4"><ArrowLeft className="w-4 h-4" />Voltar</button>
      <div className="bg-white rounded-xl p-6 shadow-sm border max-w-3xl">
        <h3 className="text-lg font-bold text-[#0A2F3D] mb-4">{isEdit ? "Editar Cotacao" : "Nova Cotacao"}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Nome do Cliente</label>
              <input required value={form.client_name} onChange={function(e) { handleChange("client_name", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="quote-client-name" disabled={isEdit} />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Tipo de Seguro</label>
              <select required value={form.insurance_type} onChange={function(e) { handleChange("insurance_type", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="quote-type" disabled={isEdit}>
                <option value="auto">Auto</option>
                <option value="residencial">Residencial</option>
                <option value="vida">Vida</option>
                <option value="empresarial">Empresarial</option>
              </select>
            </div>
          </div>
          {!isEdit && (
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">ID do Cliente</label>
              <input required value={form.client_id} onChange={function(e) { handleChange("client_id", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="quote-client-id" />
            </div>
          )}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Descricao</label>
            <input required value={form.description} onChange={function(e) { handleChange("description", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="quote-description" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Detalhes</label>
            <textarea value={form.details} onChange={function(e) { handleChange("details", e.target.value); }} rows={2} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="quote-details" />
          </div>
          <ProposalEditor proposals={form.proposals} selectedIndex={form.selected_index} insurers={insurers} onChange={function(p) { handleChange("proposals", p); }} onSelectIndex={function(i) { handleChange("selected_index", i); }} />
          {isEdit && (
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Status</label>
              <select value={form.status} onChange={function(e) { handleChange("status", e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="quote-status">
                <option value="aberta">Aberta</option>
                <option value="respondida">Respondida</option>
                <option value="cancelada">Cancelada</option>
              </select>
            </div>
          )}
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onCancel} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Cancelar</button>
            <button type="submit" disabled={saving} className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-medium hover:bg-blue-600 disabled:opacity-50" data-testid="save-quote-btn">
              {saving ? "Salvando..." : (isEdit ? "Salvar" : "Criar Cotacao")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
